import { Button, InputAdornment, TextField } from "@mui/material";
import React from "react";

interface IQuantityPicker {
    action:string,
    available: number,
    value: number,
    onChange: (qty: number) => void
}

export const QuantityPicker: React.FC<IQuantityPicker> = ({
    action,
    available,
    value,
    onChange,
    ...props
}: IQuantityPicker) => {

    return (
        <TextField
            fullWidth
            required
            variant="outlined"
            label={(action) + " Quantity"}
            type="number"
            inputProps={{ min: 1, max: available }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => onChange(available)}
                            disabled={value === available}
                        >All</Button>
                    </InputAdornment>
                )
            }}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                onChange(parseInt(e.currentTarget.value) <= available ?
                    parseInt(e.currentTarget.value) :
                    available);
            }
            }
            helperText={<><strong>{available - value}</strong> available remaining</>}
        />
    );
}